import { useState } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { PaymentMethod } from '@/models';
import { stripePromise } from '@/config';
import { TariffsPaymentMethodSelector } from '../TariffsPaymentMethodSelector';
import { CardCheckoutForm } from './Card';
import CryptoCheckoutForm from './Crypto/CryptoCheckoutForm';

type TariffsPaymentMethodProps = {
  tariffCost: number;
  planId: number;
  tariffType?: string;
};

const TariffsPaymentMethod = ({
  tariffCost,
  planId,
  tariffType,
}: TariffsPaymentMethodProps) => {
  const [currentPaymentMethod, setCurrentPaymentMethod] =
    useState<PaymentMethod>();
  const onPaymentMethodChange = (paymentMethod: PaymentMethod) => {
    setCurrentPaymentMethod(paymentMethod);
  };

  return (
    <div>
      <TariffsPaymentMethodSelector
        onPaymentMethodChange={onPaymentMethodChange}
        tariffCost={tariffCost}
      />
      {currentPaymentMethod?.isCrypto ? (
        <CryptoCheckoutForm
          currency={currentPaymentMethod.symbol}
          planId={planId}
          tariffType={tariffType}
        />
      ) : (
        <Elements
          stripe={stripePromise}
          options={{
            mode: 'payment',
            currency: 'usd',
            amount: Math.round(tariffCost * 100),
            paymentMethodTypes: ['card'],
          }}
        >
          <CardCheckoutForm planId={planId} tariffType={tariffType} />
        </Elements>
      )}
    </div>
  );
};

export default TariffsPaymentMethod;
